import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import * as React from 'react';
function Checkbox({ className, ref, ...props }) {
    return (_jsx(CheckboxPrimitive.Root, { ref: ref, className: cn(
        // The box stays 16px; touch-hitbox grows the target around it (24px
        // everywhere, 44px where a finger is the primary pointer) without
        // moving layout.
        'peer touch-hitbox border-primary ring-offset-background focus-visible:ring-ring data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground relative h-4 w-4 shrink-0 rounded-sm border focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50', className), ...props, children: _jsx(CheckboxPrimitive.Indicator, { className: cn('flex items-center justify-center text-current'), children: _jsx(Check, { className: "h-4 w-4" }) }) }));
}
export { Checkbox };
